import { render, staticRenderFns } from "./PoiBit.vue?vue&type=template&id=0040f21c&"
import script from "./PoiBit.vue?vue&type=script&lang=js&"
export * from "./PoiBit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports